<script lang="ts" setup>
import { computed, unref } from 'vue'
import { storeToRefs } from 'pinia'
import { useGo } from '@/hooks/web/usePage'
import { useMenuSetting } from '@/hooks/setting/useMenuSetting'
import { useDesign } from '@/hooks/web/useDesign'
import { PageEnum } from '@/enums/pageEnum'
import { useUserStore } from '@/store/modules/user'

const props = defineProps({
  // 当前父组件的主题
  theme: { type: String, validator: (v: string) => ['light', 'dark'].includes(v) },
  // 是否显示标题
  showTitle: { type: Boolean, default: true },
  // 折叠菜单时也会显示标题
  alwaysShowTitle: { type: Boolean },

  // logo
  logo: { type: String, default: '' },

  // name
  name: { type: String },
})
const userStore = useUserStore()
const { userInfo } = storeToRefs(userStore)

const { prefixCls } = useDesign('app-logo')
const { getCollapsedShowTitle } = useMenuSetting()
// const { title } = useGlobSetting()
const go = useGo()
const getAppLogoClass = computed(() => [
  prefixCls,
  props.theme,
  { 'collapsed-show-title': unref(getCollapsedShowTitle) },
])
const getTitleClass = computed(() => [
  `${prefixCls}__title`,
  {
    'xs:opacity-0': !props.alwaysShowTitle,
  },
])

const getSubTitleClass = computed(() => [
  `${prefixCls}__subtitle`,
  {
    'xs:opacity-0': !props.alwaysShowTitle,
  },
])

function goHome() {
  go(PageEnum.BASE_HOME)
}

const origin = window.location.origin
// const origin = 'https://wxkpxt.chenlingkj.com.cn'
</script>

<template>
  <div class="anticon" :class="getAppLogoClass" @click="goHome">
    <img v-if="!origin.includes('kpxt')" :src="props.logo || userInfo?.tenantRespVO?.companyLogo">
    <div>
      <div v-show="showTitle" class="truncate md:opacity-100" :class="getTitleClass">
        {{ props.name || `${userInfo?.tenantRespVO?.name}` }}
      </div>
      <div v-if="origin.includes('kpxt')" class="mt-1" :class="getSubTitleClass">
        —— 开票及充装系统
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@prefix-cls: ~"@{namespace}-app-logo";

.@{prefix-cls} {
  display: flex;
  align-items: center;
  padding-left: 7px;
  cursor: pointer;
  transition: all 0.2s ease;

  &.light {
    border-bottom: 1px solid var(--border-color);
  }

  &.collapsed-show-title {
    padding-left: 20px;
  }

  &.dark &__title {
    margin-left: 5px;
    color: @white;
  }

  &.dark &__subtitle {
    margin-left: 25px;
    font-size: 12px;
    color: @white;
  }

  &__title {
    margin-left: 20px;
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    transition: all 0.5s;
  }

  &__subtitle {
    margin-left: 25px;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    transition: all 0.5s;
  }
}
</style>
